import { render } from "./SectionGridCard.vue?vue&type=template&id=fd837458&scoped=true"
import script from "./SectionGridCard.vue?vue&type=script&lang=js"
export * from "./SectionGridCard.vue?vue&type=script&lang=js"

import "./SectionGridCard.vue?vue&type=style&index=0&id=fd837458&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd837458"]])

export default __exports__